import React from "react";
import { useIntl } from "react-intl";
import MenuItem from "@material-ui/core/MenuItem";

export default ({ onRemoveCallback, onComplete, question }) => {
  const intl = useIntl();

  return (
    <MenuItem
      onClick={() => {
        onRemoveCallback(question);
        onComplete();
      }}
    >
      {intl.formatMessage({ id: "app.surveyBuilder.removeButtonText" })}
    </MenuItem>
  );
};
